/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Color_Image_Input_Select_ColorInputs */

const en_admin_resources_color_image_input_select_color = /** @type {(inputs: Admin_Resources_Color_Image_Input_Select_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select color`)
};

const de_admin_resources_color_image_input_select_color = /** @type {(inputs: Admin_Resources_Color_Image_Input_Select_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe auswählen`)
};

const es_admin_resources_color_image_input_select_color = /** @type {(inputs: Admin_Resources_Color_Image_Input_Select_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar color`)
};

const fr_admin_resources_color_image_input_select_color = /** @type {(inputs: Admin_Resources_Color_Image_Input_Select_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner la couleur`)
};

/** @type {(inputs: Admin_Resources_Color_Image_Input_Select_ColorInputs) => LocalizedString} */
const it_admin_resources_color_image_input_select_color = en_admin_resources_color_image_input_select_color;

/** @type {(inputs: Admin_Resources_Color_Image_Input_Select_ColorInputs) => LocalizedString} */
const pt_br2_admin_resources_color_image_input_select_color = en_admin_resources_color_image_input_select_color;

/** @type {(inputs: Admin_Resources_Color_Image_Input_Select_ColorInputs) => LocalizedString} */
const pl_admin_resources_color_image_input_select_color = en_admin_resources_color_image_input_select_color;

/** @type {(inputs: Admin_Resources_Color_Image_Input_Select_ColorInputs) => LocalizedString} */
const hu_admin_resources_color_image_input_select_color = en_admin_resources_color_image_input_select_color;

/** @type {(inputs: Admin_Resources_Color_Image_Input_Select_ColorInputs) => LocalizedString} */
const ro_admin_resources_color_image_input_select_color = en_admin_resources_color_image_input_select_color;

/**
* | output |
* | --- |
* | "Select color" |
*
* @param {Admin_Resources_Color_Image_Input_Select_ColorInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_color_image_input_select_color = /** @type {((inputs?: Admin_Resources_Color_Image_Input_Select_ColorInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Color_Image_Input_Select_ColorInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_color_image_input_select_color(inputs)
	if (locale === "de") return de_admin_resources_color_image_input_select_color(inputs)
	if (locale === "es") return es_admin_resources_color_image_input_select_color(inputs)
	if (locale === "fr") return fr_admin_resources_color_image_input_select_color(inputs)
	if (locale === "it") return it_admin_resources_color_image_input_select_color(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_color_image_input_select_color(inputs)
	if (locale === "pl") return pl_admin_resources_color_image_input_select_color(inputs)
	if (locale === "hu") return hu_admin_resources_color_image_input_select_color(inputs)
	return ro_admin_resources_color_image_input_select_color(inputs)
});
export { admin_resources_color_image_input_select_color as "admin.resources.color_image_input.select_color" }